import React from "react";
import GrossBranchListForm from './list/GrossBranchListForm';
import CreateGrossBranchForm from './create/CreateGrossBranchForm'

const GrossBranchView = ({ displayList }) => {
  return displayList ? (
    <GrossBranchListForm />
  ) : (
    <CreateGrossBranchForm />
  );
};

export default GrossBranchView;
